var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7632 5.87091C10.7632 9.25783 7 11.8921 7 11.8921C7 11.8921 3.23676 9.25783 3.23676 5.87091C3.23676 4.87284 3.63324 3.91564 4.33898 3.2099C5.04473 2.50415 6.00193 2.10767 7 2.10767C7.99808 2.10767 8.95527 2.50415 9.66102 3.2099C10.3668 3.91564 10.7632 4.87284 10.7632 5.87091V5.87091Z",
    stroke: "#9AAEBB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99996 7.37632C7.83131 7.37632 8.50526 6.70237 8.50526 5.87102C8.50526 5.03967 7.83131 4.36572 6.99996 4.36572C6.1686 4.36572 5.49466 5.03967 5.49466 5.87102C5.49466 6.70237 6.1686 7.37632 6.99996 7.37632Z",
    stroke: "#9AAEBB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyLocation);
export default __webpack_public_path__ + "static/media/greyLocation.fe4b7cb39308db0c9dbabe6229856972.svg";
export { ForwardRef as ReactComponent };